import { Model } from "@game.object/ts-game-toolbox/dist/src/abstract/mvc/Model";
import { string_from_hash } from "../../tools/StringHelper";
import { ModelCollection } from "./ModelCollection";

export class BlockModel extends Model<ModelCollection> {
    public static next_id: number = 0;
    public id: number = BlockModel.next_id++;
    // 
    public previous_hash: number = 0;
    public hash: number = 0;
    public nonce: number = 0;
    public data: string = "";
    public is_computing_hash = false;

    public mine() {
        this.is_computing_hash = true;
        this.hash = this.compute_hash();
        this.is_computing_hash = !this.has_valid_hash();
        if (this.is_computing_hash) {
            this.nonce = (this.nonce + 1) & 0xffff;
            if (this.nonce === 0) console.warn("restarting starting nonce on block " + this.id);
        };
    }

    public compute_hash(): number {
        return this.hash = this.get_hash(this.get_complete_data());
    }

    public get_complete_data(): string {
        return [
            string_from_hash(this.previous_hash),
            this.data,
            string_from_hash(this.nonce),
        ].join('');
    }

    public get_hash(data: string): number {
        const max_value = (1 << 16) - 1;
        const primenumber = 0xAE49;
        return data.split('').reduce<number>((current_hash: number, next_char: string): number => {
            const new_value = next_char.charCodeAt(0);
            const munch: number = (current_hash << 2) + (new_value ^ primenumber) * ((new_value + 1) ^ primenumber);
            return ((munch >> 2) & max_value);
        }, 0);
    }

    public has_valid_hash(): boolean {
        return (this.hash & 0xf000) === 0x0 && this.hash !== 0;
    }

    public get is_valid(): boolean {
        return this.has_valid_hash();
    }

}